import { useIntl } from "react-intl";

const useGetDir = () => {
    const { locale } = useIntl();

    if (locale === "ar") {
        return "rtl";
    }
    return "ltr";
};

export default useGetDir;
